var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBill = function SvgIconBill(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#616A88",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.148 14.24H15.55v-.7H.149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.392h15.698v-1H0v1zm.296-.298h15.105v-.405H.296v.405zM2.949 1.373l.386.193.314.157.313-.157 1.087-.544 1.4.7.313-.156 1.087-.544 1.087.544.312.156.313-.156 1.093-.544 1.08.543.314.158.314-.157.387-.193v11.466h.7V.239l-1.4.7-1.393-.7-1.407.7-1.4-.7-1.4.7-1.4-.7-1.4.7-1.4-.7v12.597h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.597 0L12.05.774l-1.393-.7-1.407.7-1.4-.7-1.4.7-1.4-.7-1.4.7L2.1 0v12.984h.997V1.612l.551.277 1.4-.701 1.4.701 1.401-.701 1.4.7 1.404-.7 1.395.701.553-.277v11.374h.996V0zm-2.942.405l1.394.7L13.3.48V12.69h-.404V1.133l-.85.424-1.392-.7-1.407.7-1.399-.7-1.4.7-1.4-.7-1.4.7-.849-.424v11.554h-.404V.48l1.252.626 1.4-.7 1.4.7 1.401-.7 1.4.7 1.406-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.348 5.14h4.2v-.7h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.497 4.994H8.4V4.59H4.497v.405zm-.297.297h4.497v-1H4.2v1zM9.949 5.14h1.4v-.7h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.097 4.994h1.104V4.59h-1.104v.405zm-.296.297h1.696v-1H9.8v1zM4.348 7.94h4.2v-.7h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.497 7.794H8.4V7.39H4.497v.405zm-.297.297h4.497v-1H4.2v1zM9.949 7.94h1.4v-.7h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.097 7.794h1.104V7.39h-1.104v.405zm-.296.297h1.696v-1H9.8v1zM4.348 10.74h4.2v-.7h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.497 10.595H8.4v-.406H4.497v.406zm-.297.297h4.497v-1H4.2v1zM9.949 10.74h1.4v-.7h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.097 10.595h1.104v-.406h-1.104v.406zm-.296.297h1.696v-1H9.8v1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bill.91f19e11.svg";
export { ForwardRef as ReactComponent };